import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";
import {componentsLoader} from "app/service/components-loader";

@AsStimulusController('crm-person-detail-applications-controller')
export default class extends Typed(Controller<HTMLElement>)
{
    public connect(): void {
        componentsLoader.load(this.element);
    }
}
